import { all, fork, takeEvery } from 'redux-saga/effects';
import { loadEntities, deleteEntity, updateEntity } from 'helpers/utilHelpers';
import {
  LOAD_ARTICLES,
  LOAD_ARTICLE_CATEGORIES,
  LOAD_ARTICLE_TAGS,
  LOAD_CATEGORIES_LAST_ARTICLES,
  LOAD_ARTICLE_BY_ID,
  UPDATE_ARTICLE,
  UPDATE_ARTICLE_CATEGORY,
  UPDATE_ARTICLE_TAG,
  DELETE_ARTICLE,
  DELETE_ARTICLE_CATEGORY,
  DELETE_ARTICLE_TAG,
} from 'constants/ActionTypes';

function* loadArticles() {
  yield takeEvery(LOAD_ARTICLES, loadEntities);
}

function* loadArticleCategories() {
  yield takeEvery(LOAD_ARTICLE_CATEGORIES, loadEntities);
}

function* loadArticleTags() {
  yield takeEvery(LOAD_ARTICLE_TAGS, loadEntities);
}

function* loadCategoriesLastArticles() {
  yield takeEvery(LOAD_CATEGORIES_LAST_ARTICLES, loadEntities);
}

function* loadArticleById() {
  yield takeEvery(LOAD_ARTICLE_BY_ID, loadEntities);
}

function* updateArticle() {
  yield takeEvery(UPDATE_ARTICLE, updateEntity);
}

function* updateArticleCategory() {
  yield takeEvery(UPDATE_ARTICLE_CATEGORY, updateEntity);
}

function* updateArticleTag() {
  yield takeEvery(UPDATE_ARTICLE_TAG, updateEntity);
}

function* deleteArticle() {
  yield takeEvery(DELETE_ARTICLE, deleteEntity);
}

function* deleteArticleCategory() {
  yield takeEvery(DELETE_ARTICLE_CATEGORY, deleteEntity);
}

function* deleteArticleTag() {
  yield takeEvery(DELETE_ARTICLE_TAG, deleteEntity);
}

export default function* rootSaga() {
  yield all([
    fork(updateArticle),
    fork(updateArticleCategory),
    fork(updateArticleTag),
    fork(deleteArticle),
    fork(deleteArticleCategory),
    fork(deleteArticleTag),
    fork(loadArticleById),
    fork(loadCategoriesLastArticles),
    fork(loadArticles),
    fork(loadArticleCategories),
    fork(loadArticleTags),
  ]);
}
